module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-3@2x-851c5deb785dd0fe1aa7d9c2d449c860.png";